import {HttpErrorResponse, HttpEvent, HttpHandler, HttpHeaders, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {Observable, throwError} from 'rxjs';
import {catchError} from 'rxjs/operators';
import {DataSharingService} from '../main/data-sharing.service';
import {AuthService} from './auth.service';
@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  constructor(
    public auth: AuthService,
    private dataSharingService: DataSharingService,
    private router: Router,
  ) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!!this.auth.getToken()) {
      if (!request.url.includes('thumbnails')
        && !request.url.includes('www.omdbapi.com')
        && !request.url.includes('api.themoviedb.org/3')
        && !request.url.includes('/quicklinks/public')) {
        const cloned = request.clone({
          headers: request.headers.set('Authorization', this.auth.getToken()),
        });
        return next.handle(cloned);
      }
      return next.handle(request);
    } else {
      return next.handle(request).pipe(
        catchError((error: HttpErrorResponse) => {
          // ErrorInterceptor owns 440 session teardown and navigation. Handling
          // it here too would issue a second navigation for tokenless requests.
          if (error.status === 401 && !this.auth.getToken()) {
            this.router.navigateByUrl('/login', {replaceUrl: true});
          }
          return throwError(error);
        }),
      );
    }
  }
}
